import React from 'react'
import moment from 'moment'

const SupportTable = ({ data, getMessgaes }) => {

    return (
        <div className='table-responsive'>

            <table className='jean-table table'>
                <tbody>
                    {
                        data?.map((item, i) => {

                            return (
                                <tr key={item.id}>
                                    <td className='ps-xl-4'>
                                        <div className='therapist-info'>
                                            <h4 className='mb-1 fs-5'>Sr.</h4>
                                            <p className='mb-0'>{i+1}</p>
                                        </div>
                                    </td>
                                    <td>
                                        <div className='therapist-info'>
                                            <h4 className='mb-1 fs-5'>Date</h4>
                                            <p className='mb-0'>{moment(item.created_at).format('DD MMM, YYYY')}</p>
                                        </div>
                                    </td>

                                    <td>
                                        <div className='therapist-info'>
                                            <h4 className='mb-1 fs-5'>Subject</h4>
                                            <p className='mb-0'>{item.title}</p>
                                        </div>
                                    </td>
                                    
                                    <td className='text-end pe-3'>
                                        <div className=''>
                                            <button
                                                onClick={() => {
                                                    getMessgaes(item?.id)
                                                }}
                                                className="ps-dropdown__toggle border-0 bg-green text-white  py-2 px-3 rounded-4 ">
                                                <i className="bi bi-wechat fs-4 me-2"></i>Chat Now
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            )
                        })
                    }
                    {
                        data?.length === 0 &&
                        <div className="alert alert-success ps-4">No Query Found !!</div>
                    }
                </tbody>
            </table>

        </div>
    )
}

export default SupportTable